import type { DraftEntryLink } from "@/entities/bot-builder"
import { NativeSelect } from "@/shared/ui/native-select"

/** Выбор метки для статистики: пусто это все люди, иначе только пришедшие по метке. */
export function UtmFilter({
	links,
	value,
	onChange,
	className,
}: {
	links: DraftEntryLink[]
	value: string
	onChange: (code: string) => void
	className?: string
}) {
	if (links.length === 0) return null
	return (
		<NativeSelect
			aria-label="Считать людей по метке"
			className={className}
			value={value}
			onChange={(event) => onChange(event.target.value)}
		>
			<option value="">Все люди</option>
			{links.map((link) => (
				<option key={link.id} value={link.code}>
					Метка: {link.name} ({link.code})
				</option>
			))}
		</NativeSelect>
	)
}
